'use strict';

var portConfigurationOverride = require('actionGroups/portConfigurationOverride/PortConfigurationOverride');

module.exports = {
  Model: portConfigurationOverride,
};
